import { render, staticRenderFns } from "./PurchasingPending.vue?vue&type=template&id=ab5c001a&"
import script from "./PurchasingPending.vue?vue&type=script&lang=js&"
export * from "./PurchasingPending.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingPending.vue?vue&type=style&index=0&id=ab5c001a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports